import React from 'react';
import { observer, inject } from 'mobx-react';
import ButtonSpinner from '../ButtonSpinner';
import LoadingSpinner from '../LoadingSpinner';
import { Modal, FormGroup, FormControl, ControlLabel, Button } from 'react-bootstrap';
import TinyMCE from 'react-tinymce';

@inject('policyStore')
@observer
export default class AddPolicy extends React.Component {
    componentDidMount() {
    }
    render() {
        if (!this.props.policyStore.LoadingDocForUpdate) {
            return (
                <Modal show={this.props.policyStore.ShowAddPolicy} bsSize="lg"  >
                    <Modal.Header>Add/Edit Policy</Modal.Header>
                    <Modal.Body>
                        <FormGroup controlId="DocName" >
                            <ControlLabel>Document Name</ControlLabel>
                            <FormControl type="text" value={this.props.policyStore.AddPolicyRequest.DocName} name="DocName" placeholder="Enter document name" onChange={(e) => { this.props.policyStore.UpdateAddPolicyRequestProperty(e.target.name, e.target.value) }} />
                        </FormGroup>
                        <FormGroup controlId="Description" >
                            <ControlLabel>Description</ControlLabel>
                            <FormControl componentClass="textarea" value={this.props.policyStore.AddPolicyRequest.Description} name="Description" placeholder="Enter Description" onChange={(e) => { this.props.policyStore.UpdateAddPolicyRequestProperty(e.target.name, e.target.value) }} />
                        </FormGroup>
                        <FormGroup controlId="Content" >
                            <TinyMCE
                                content={this.props.policyStore.AddPolicyRequest.Content}
                                config={{
                                    plugins: 'autolink link image advcode table lists print preview textcolor',
                                    toolbar: 'formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify  | numlist bullist outdent indent  | removeformat'
                                }}
                                onChange={(content) => { this.props.policyStore.UpdateAddPolicyRequestProperty("Content", content) }} />
                        </FormGroup>
                        <FormGroup controlId="Version" >
                            <ControlLabel>Version</ControlLabel>
                            <FormControl type="text" value={this.props.policyStore.AddPolicyRequest.Version} name="Version" placeholder="Enter version number" onChange={(e) => { this.props.policyStore.UpdateAddPolicyRequestProperty(e.target.name, e.target.value) }} />
                        </FormGroup>
                        <FormGroup controlId="Category" >
                            <ControlLabel>Category</ControlLabel>
                            <FormControl type="text" value={this.props.policyStore.AddPolicyRequest.Category} name="Category" placeholder="Enter Category" onChange={(e) => { this.props.policyStore.UpdateAddPolicyRequestProperty(e.target.name, e.target.value) }} />
                        </FormGroup>
                        <FormGroup controlId="Subcategory" >
                            <ControlLabel>Subcategory</ControlLabel>
                            <FormControl type="text" value={this.props.policyStore.AddPolicyRequest.Subcategory} name="SubCategory" placeholder="Enter Subcategory" onChange={(e) => { this.props.policyStore.UpdateAddPolicyRequestProperty(e.target.name, e.target.value) }} />
                        </FormGroup>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={() => { this.props.policyStore.ToggleAddPolicyModal(); }}>Close</Button>
                        <Button onClick={() => { this.props.policyStore.AddPolicy(); }}>Save <ButtonSpinner IsLoading={this.props.policyStore.IsAddingPolicy} /> </Button>
                    </Modal.Footer>
                </Modal>
            );
        }
        else {
            return (<LoadingSpinner />);
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/Policies/AddPolicy.js